import { Box, CircularProgress } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
export var Loader = function Loader() {
  return /*#__PURE__*/_jsx(Box, {
    sx: {
      display: 'flex',
      justifyContent: 'center',
      m: 2
    },
    "data-element": "Box",
    "data-component": "Loader",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsx(CircularProgress, {
      size: 16,
      "data-element": "CircularProgress",
      "data-component": "Loader",
      "data-source-file": "index.tsx"
    })
  });
};